import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-types-papi';
import DeviationThumbView from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import LoadableDuperbrowseContext from '../../../../../contexts/LoadableDuperbrowseContext';
import PostEditableItem from '../../../../UserWidgets/_partials/PostEditableItem';
import EmptyState from '../../_partials/EmptyState';

import s from './FeaturedList.scss';

export interface Props {
  streamId: string;
  items: PapiDeviation[];
}

const FeaturedList: React.FC<Props> = ({ items, streamId }) => {
  const { t } = useTranslation();
  if (!items.length) {
    return (
      <EmptyState
        view="small"
        postType="featuredJournal"
        className={s['empty-state']}
        CTAButtonModalType={ModalType.JOURNAL}
      />
    );
  }

  return (
    <div className={s['root']}>
      <LoadableDuperbrowseContext
        streamId={streamId}
        parent={{ title: t('navigation.route.posts') }}
      >
        {items.map((item, i) => (
          <PostEditableItem
            key={`featured-journal-${i}-${item.deviationId}`}
            className={s['item']}
            item={item}
          >
            <DeviationThumbView deviation={item} height={343} />
          </PostEditableItem>
        ))}
      </LoadableDuperbrowseContext>
    </div>
  );
};
FeaturedList.displayName = 'FeaturedList';

export default FeaturedList;
